import config from '../config.json';

function resolveApiBase() {
  return (
    (typeof window !== 'undefined' && window.config?.apiURI) || config.apiURI
  );
}

function normalizeImagePath(imagePath) {
  if (imagePath == null || imagePath === '') return '';
  if (typeof imagePath === 'string') return imagePath.trim();
  if (typeof imagePath === 'object' && typeof imagePath.url === 'string') {
    return imagePath.url.trim();
  }
  return String(imagePath).trim();
}

/**
 * Resolve CMS banner (and similar upload) image paths for display.
 * Absolute https URLs are used as-is; /uploads paths get the backend base URL.
 */
export function getImageUrl(imagePath) {
  const path = normalizeImagePath(imagePath);
  if (!path) return '';

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  if (path.startsWith('/uploads')) {
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    return `${resolveApiBase()}${cleanPath}`;
  }

  return path;
}

/**
 * Format a resolved image URL for libraries that wrap values in CSS url(...),
 * e.g. react-card-slider-component. Absolute URLs must be quoted.
 */
export function formatBackgroundImageUrl(imagePath) {
  const url = getImageUrl(imagePath);
  if (!url) return '';
  if (url.includes('://')) {
    return `"${url.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
  }
  return url;
}
